<template>
      <div id="main_container">
        <div>
            <p class="title is-spaced">
              We're on it!
            </p>
            <p class="subtitle">
              Let's update your account with the most recent<br/>
              business bank statements
            </p>
            <p class="small-title"> 
              Upload last 4 months of business bank statements
            </p>
            <div v-for="(item, index) in months_generated" v-bind:key="index">
            <div id="filebox" :class="ready ? 'faded' : ''">
                <p class="file-label-month">{{ item.replace(/_/g, ' ') }}</p>
                <div class="file-input-container">
                  <div class="upload-box"  :class="fileList[index]? 'upload-box-selected': '' ">
                    <div v-if="fileList[index]">
                      <label class="upload-label-completed">{{fileList[index].file.name}}</label> &nbsp;&nbsp;&nbsp;&nbsp;
                      <label class="upload-label-size-completed">{{ humanFileSize(fileList[index].file.size) }}</label>
                    </div>
                    <label class="upload-label-missing" v-else>Add file</label>
                    <div class="upload-input-wrapper" v-if="!fileList[index]">
                      <div class="upload-fake">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g id="icon-wrapper" clip-path="url(#clip0_3029_99)">
                          <g id="Union">
                          <path d="M0.499756 9.89918C0.632364 9.89918 0.759541 9.95186 0.853309 10.0456C0.947077 10.1394 0.999756 10.2666 0.999756 10.3992V12.8992C0.999756 13.1644 1.10511 13.4188 1.29265 13.6063C1.48019 13.7938 1.73454 13.8992 1.99976 13.8992H13.9998C14.265 13.8992 14.5193 13.7938 14.7069 13.6063C14.8944 13.4188 14.9998 13.1644 14.9998 12.8992V10.3992C14.9998 10.2666 15.0524 10.1394 15.1462 10.0456C15.24 9.95186 15.3671 9.89918 15.4998 9.89918C15.6324 9.89918 15.7595 9.95186 15.8533 10.0456C15.9471 10.1394 15.9998 10.2666 15.9998 10.3992V12.8992C15.9998 13.4296 15.789 13.9383 15.414 14.3134C15.0389 14.6885 14.5302 14.8992 13.9998 14.8992H1.99976C1.46932 14.8992 0.960615 14.6885 0.585542 14.3134C0.21047 13.9383 -0.000244141 13.4296 -0.000244141 12.8992V10.3992C-0.000244141 10.2666 0.0524343 10.1394 0.146202 10.0456C0.239971 9.95186 0.367148 9.89918 0.499756 9.89918Z" fill="#5670B5"/>
                          <path d="M7.64576 1.14518C7.6922 1.09862 7.74738 1.06168 7.80812 1.03647C7.86887 1.01127 7.93399 0.998291 7.99976 0.998291C8.06552 0.998291 8.13064 1.01127 8.19139 1.03647C8.25213 1.06168 8.30731 1.09862 8.35376 1.14518L11.3538 4.14518C11.4476 4.23907 11.5004 4.36641 11.5004 4.49918C11.5004 4.63196 11.4476 4.7593 11.3538 4.85318C11.2599 4.94707 11.1325 4.99982 10.9998 4.99982C10.867 4.99982 10.7396 4.94707 10.6458 4.85318L8.49976 2.70618V11.4992C8.49976 11.6318 8.44708 11.759 8.35331 11.8527C8.25954 11.9465 8.13236 11.9992 7.99976 11.9992C7.86715 11.9992 7.73997 11.9465 7.6462 11.8527C7.55243 11.759 7.49976 11.6318 7.49976 11.4992V2.70618L5.35376 4.85318C5.30727 4.89967 5.25208 4.93655 5.19134 4.96171C5.1306 4.98687 5.0655 4.99982 4.99976 4.99982C4.93401 4.99982 4.86891 4.98687 4.80817 4.96171C4.74743 4.93655 4.69224 4.89967 4.64576 4.85318C4.59927 4.8067 4.56239 4.75151 4.53723 4.69077C4.51207 4.63003 4.49912 4.56493 4.49912 4.49918C4.49912 4.43344 4.51207 4.36834 4.53723 4.3076C4.56239 4.24686 4.59927 4.19167 4.64576 4.14518L7.64576 1.14518Z" fill="#5670B5"/>
                          </g>
                          </g>
                          <defs>
                          <clipPath id="clip0_3029_99">
                          <rect width="16" height="16" fill="white"/>
                          </clipPath>
                          </defs>
                        </svg>
                        Upload
                      </div>
                      <input class="upload-input" type="file" name="file" id="file-input" @change="selectFile($event,index)" style="cursor: pointer"/>
                    </div>
                    <div v-else>
                      <div class="icon_file_uploaded">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path d="M5.66738 11L2.16738 7.5L3.15438 6.506L5.66738 9.019L10.9804 3.706L11.9674 4.7M7.06738 0.5C6.14813 0.5 5.23788 0.68106 4.3886 1.03284C3.53932 1.38463 2.76765 1.90024 2.11764 2.55025C0.804881 3.86301 0.0673828 5.64348 0.0673828 7.5C0.0673828 9.35651 0.804881 11.137 2.11764 12.4497C2.76765 13.0998 3.53932 13.6154 4.3886 13.9672C5.23788 14.3189 6.14813 14.5 7.06738 14.5C8.9239 14.5 10.7044 13.7625 12.0171 12.4497C13.3299 11.137 14.0674 9.35651 14.0674 7.5C14.0674 6.58075 13.8863 5.67049 13.5345 4.82122C13.1828 3.97194 12.6671 3.20026 12.0171 2.55025C11.3671 1.90024 10.5954 1.38463 9.74617 1.03284C8.89689 0.68106 7.98664 0.5 7.06738 0.5Z" fill="#28A745"/>
                        </svg>
                      </div>
                      <div class="icon_file_delete"  @click="deleteFile(index)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M7.56738 15.5C5.57832 15.5 3.67049 14.7098 2.26409 13.3033C0.857602 11.8967 0.0673828 9.98906 0.0673828 8C0.0673828 6.01094 0.857602 4.10311 2.26409 2.69671C3.67069 1.29022 5.57832 0.500001 7.56738 0.500001C9.55645 0.500001 11.4643 1.29022 12.8707 2.69671C14.2772 4.10331 15.0674 6.01094 15.0674 8C15.065 9.98839 14.2741 11.8948 12.868 13.3007C11.462 14.7067 9.55557 15.4976 7.56738 15.5ZM10.4597 6.07102C10.5912 5.94397 10.6661 5.76934 10.6677 5.58648C10.6693 5.40362 10.5974 5.22773 10.4681 5.0984C10.3388 4.96907 10.1629 4.89717 9.98003 4.89876C9.79718 4.90036 9.62266 4.97536 9.49561 5.10685L7.56738 7.03578L5.63916 5.10685C5.466 4.93963 5.2175 4.87605 4.98523 4.93974C4.75306 5.00343 4.57169 5.18481 4.50799 5.41698C4.4443 5.64926 4.50788 5.89775 4.6751 6.07091L6.60333 7.99984L4.6751 9.92876C4.54361 10.0558 4.46861 10.2303 4.46701 10.4132C4.46542 10.596 4.53733 10.7719 4.66665 10.9013C4.79598 11.0306 4.97186 11.1025 5.15473 11.1009C5.33759 11.0993 5.5121 11.0243 5.63915 10.8928L7.56738 8.96389L9.4956 10.8928C9.62265 11.0243 9.79716 11.0993 9.98003 11.1009C10.1629 11.1025 10.3388 11.0306 10.4681 10.9013C10.5974 10.7719 10.6693 10.5961 10.6677 10.4132C10.6661 10.2303 10.5911 10.0558 10.4597 9.92876L8.53143 7.99984L10.4597 6.07102Z" fill="#E6E6E6"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <!-- <label class="upload-word">Upload</label> -->
                  <!-- <input type="file" name="file" id="file-input" multiple @change="selectFile($event,0)"/> -->
                </div>
              </div>
            </div>
            <!-- <hr class="ccc" /> -->
            <!-- <div class="advantage_separator" style="margin-top: 30px; margin-bottom: 30px"></div> -->
            <div class="buttons" id="done_adding_files_container">
              <a
                class="button is-link padded-button next-button continue-button"
                @click="uploadFiles"
                :disabled="selectedFiles.length < 4"
                >Submit</a
              >
            </div>
          </div>
          <!-- <div class="advantage_separator" style="margin-top: 30px; margin-bottom: 30px"></div> -->
          <p class="notes">
            *Cardiff can fund same day for applications approved by 5:00 p.m.
            Eastern Time on bank business days.
          </p>
    </div>
</template>
  
<script>
import Input from "@/components/shared/Input";
import MyUtils from "@/utils/MyUtils";
import $ from "jquery";
  
function getDeviceType() {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
}
function getLastFourMonths() {
  const months = [];
  const now = new Date();
  for (let i = 1; i <= 4; i++) {
      const monthDate = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const month = monthDate.toLocaleString('default', { month: 'long' });
      const year = monthDate.getFullYear();
      months.push(`${month}_${year}`);
  }
  return months;
}

export default {
    name: "RenewalBanksUpload",
    components: {},
    props: {
      itemid: String,
      api: String,
      link: String,
    },
    data() {
      return {
        obj: "financials",
        inputs: {
          ts: "",
        },
        monthOptions: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        attached: false,
        clicked: false,
        ready: false,
        fileList: [],
        device_type: "",
        months_generated : '',
        current_month_label: '',
        current_month_index : 0,
        selectedFiles: [],
      };
    },
    mounted: function () {
      var self = this;
      this.device_type = getDeviceType();
      this.months_generated = getLastFourMonths();
      this.current_month_label = this.months_generated[0];
      // $("#transition_container").css("max-width", "100%");
    },
    methods: {
      next() {
        this.$emit("next", this.$data);
      },
      back() {
        this.$emit("back", this.$data);
      },
      humanFileSize(bytes, si = false, dp = 1) {
        const thresh = si ? 1000 : 1024;
  
        if (Math.abs(bytes) < thresh) {
          return bytes + " B";
        }
  
        const units = si
          ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
          : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
        let u = -1;
        const r = 10 ** dp;
  
        do {
          bytes /= thresh;
          ++u;
        } while (
          Math.round(Math.abs(bytes) * r) / r >= thresh &&
          u < units.length - 1
        );
  
        return bytes.toFixed(dp) + " " + units[u];
      },
      uploadFiles() {
        console.log('upload files!');
        var self = this;
        console.log(this.clicked);
        if (this.clicked === true) {
          console.log('already clicked!')
          return;
        }
        let opp_id = MyUtils.getWithExpiry("oppid");
        if (!opp_id && self.selectedFiles < 4) {
          alert("Please upload a valid file.");
          return;
        }
        this.clicked = true;
       
        var fd = new FormData();
        // $.each($("input[type='file']")[0].files, function (i, file) {
        //   fd.append("file", file);
        // });
        self.fileList.forEach((f) => {
          fd.append("fileinfo", JSON.stringify(f));
        });
        fd.append("opp_id", opp_id);
        for (let i = 0; i < this.selectedFiles.length; i++) {
            fd.append("file", this.selectedFiles[i]);
        }
        console.log('submitting files!')
        $.ajax({
          type: "POST",
          url: "/api/opportunity/upload-statements",
          contentType: false,
          processData: false,
          data: fd,
          success: function(resp){
            console.log(resp);
            // alert('file uploaded!')
            self.next();
          },
          error: function(jqXHR, textStatus, errorThrown){
            console.error("Error:", textStatus, errorThrown);
            self.clicked = false;
          }
        });
        // const input = document.getElementById('file-input');
        // for (let i = 0; i < input.files.length; i++) {
        //     fd.append('file', input.files[i]);
        // }

        // fd.append("file", $('#file-input')[0].files[0])
        //upload the file here
      },
      selectFile(event, index){
        console.log('inserting file: ',index);
        // self = this;
        let file = event.target.files[0];
        // this.selectedFiles[index]= file;
        
        this.selectedFiles.splice(index, 0, file);

        this.fileList[index] = {
            idx: index,
            file: file,
            month: this.months_generated[index]
        };
        this.$forceUpdate();
        console.log("new filelist", this.fileList);
      },
      deleteFile(index){
        console.log('deleting',this.fileList[index]);
        if (index > -1 && this.fileList[index]) { // only splice array when item is found
          // this.fileList.splice(index, 1); // 2nd parameter means remove one item only
          this.fileList[index] = null;
          this.selectedFiles.splice(index, 1);
          this.$forceUpdate();
        }
        // delete this.fileList[index];
      }
    },
    watch: {
      fileList: function (newValue, oldValue) {
        console.log(newValue);
        newValue.forEach(function(item){
          if(item && item.file){

          }
        })
      },
    }
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ccc {
  background-color: #ccc;
}
.title{
  color: #000;
  text-align: center;
  /* H1 */
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.subtitle{
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.small-title{
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px; /* 156.25% */
  margin-bottom: 64px!important;
}
.file-label-month{
  color: #676767;
  text-align: left;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

}
.upload-word{
  color: var(--Primary-40, #5670B5);
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}

.upload-box {
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* max-width: 400px; */
  font-family: Arial, sans-serif;
  max-height: 48px;
}

.upload-label {
  font-size: 16px;
  color: #333;
}
.upload-label-missing{
  color: var(--Color-delineado, #CCC);
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}
.upload-label-completed{
  color: var(--Color-text, #666);
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}
.upload-label-size-completed{
  color: var(--Opacities-Dark-40, rgba(0, 0, 0, 0.40));
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-left: 10px; 
}
.upload-box-selected{
  border-radius: 4px;
  border: 1px solid var(--Select, #28A745);
  background: #FFF;
}

.upload-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #1a73e8;
  font-weight: 500;
  text-decoration: none;
  border: none;
  background: none;
  font-size: 14px;
}

.upload-button svg {
  margin-right: 4px;
  width: 18px;
  height: 18px;
  fill: currentColor;
}
.upload-fake {
  display: flex;
  /* 
  align-items: center;
  color: #1a73e8;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer; */
  color: var(--Primary-40, #5670B5);
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}

.upload-fake svg {
  margin-right: 4px;
  width: 18px;
  height: 18px;
  fill: currentColor;
}
.upload-label {
  font-size: 16px;
  color: #333;
}

.upload-input-wrapper {
  position: relative;
  /* overflow: hidden; */
  display: inline-block;
  cursor: pointer;
}
.upload-input-wrapper:hover {
  cursor: pointer;
}
.upload-input {
  font-size: 0;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
  height: 100%;
  width: 100%;
}
.upload-input:hover{
  cursor: pointer;
}
.icon_file_uploaded,.icon_file_delete{
  display: inline-block;
  padding-right: 7px;
}
.icon_file_delete{
  cursor: pointer;
}
#file-input {
  /* height: 48px;
  width: 100%;
  background-color: #dbe9ff;
  opacity: 0; */
  /* padding: 10px; */
  /* position: absolute; */
  /* top: 0px;
  left: 0px;
  cursor: pointer;
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer; */
  /* position: relative;
  top: -60px; */
  /* position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer; */
}
.file-input-container{
  /* height: 45px; */
  /* padding-left: 5%; */
  display: block;
  padding-bottom: 16px;
  /* width: 40%; */
  /* padding: 10px; */
  /* background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-size: 14px; */

  /* margin: 0 auto;
    margin-top: 0px; */
  /* margin-top: 12px; */

  /* margin-bottom: 13px; */
  /* margin-left: 20%; */
}
.file_entry_name {
  margin-bottom: 0px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
#filebox {
  line-height: 3;
  border-radius: 5px;
  position: relative;
  transition: all 0.5s;
  /* font-size: 24px; */
  /* changes */
  font-size: 16px;
  height: 100%;
  color: #3a67d2;
  /* text-decoration: underline; */
  max-width: 442px;
  margin: 0 auto;
}
#filebox:hover {
  /* background: #3273dca3; */
  /* cursor: pointer; */
}
#filecounter {
  font-weight: bold;
  text-align: center;
  font-variant-caps: all-petite-caps;
  background: #fcfdff;
  padding: 5px;
}
.file-entry {
  padding: 8px;
  background: #e6eefb87;
  border-radius: 5px;
  margin-bottom: 10px;
  display: flex;
  align-content: center;
  align-items: center;
  border: 2px solid #5972aa;
}
.entry-info {
  text-align: right;
  padding: 5px;
}
.entry-input {
  flex-grow: 1;
  flex-basis: "auto";
}
.faded {
  opacity: 0.3;
}
/* start new design */
#success_container {
  margin-top: 64px !important;
  height: 70vh;
}
sup {
  font-size: 50%;
}
#advantages_title {
  font-size: 36px;
  font-weight: bold;
  font: normal normal bold 32px/30px Roboto;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
}
.advantages_item {
  font: normal normal normal 20px/24px Roboto;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
  /* margin-left: 5%;
  margin-right: 5%; */
}
.advantage_separator {
  border-top: 1px solid #ccc;
  padding-bottom: 10px;
  padding-top: 5px;
}

.iphone_plaid_mobile {
  display: none;
}
#shield {
  max-width: 300px;
  margin: auto;
  display: block;
}
#main_container {
  display: block;
  /* mobile */
  /* background: url("https://cardiff.b-cdn.net/img/gradient-desktop.png"); */
  /* background-repeat: no-repeat; */
  /* /* height: 390px; */
}
#image_title_container {
  /* mobile */
  background-size: contain;
  /* max-height: 650px; */
  margin-left: 5%;
}
#image_container_desktop {
  margin-top: 17px;
}
#logo {
  padding-top: 64px;
  /* margin-bottom: 21px; */
  width: 681px;
  /* height: 397px; */
}
#iphone_plaid {
  margin-bottom: 32px;
}
.notes {
  text-align: left;
  font: normal normal normal 16px/19px Roboto;
  letter-spacing: 0px;
  color: #666666;
  opacity: 1;
  margin-right: 8%;
  margin-top: 64px;
}
.pure-button {
  border-radius: 24px;
  /* border: 2px solid transparent; */
  font-family: Roboto;
  font-size: 16px;
  /* font-weight: 500; */
  font-weight: 900;
  opacity: 1;
  text-align: center;
  font: normal normal 900 16px/40px Roboto;
  letter-spacing: 0.8px;
  color: #ffffff;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
  letter-spacing: 0.9px;
  /* mobile */
  height: 46px;
  width: 240px;
}
.btn-success {
  background: #28a745 0% 0% no-repeat padding-box;
  color: #ffffff !important;
}
/* #app-column {
  padding-top: 0 !important;
} */
#lets_try {
  font: normal normal bold 32px/24px Roboto;
  letter-spacing: 0px;
  color: #000000;
  margin-bottom: 32px;
}
#done_adding_files_container{
  margin-top: 64px;
}
@media (max-width: 80em) {
}
@media (max-width: 47.999em) {
  .done_adding_files_container {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  #success_container {
    margin-top: 64px !important;
    height: auto;
  }
  #image_title_container {
    text-align: center;
    margin-top: -38px;
    padding-top: 48px;
    padding-top: 80px;

    max-height: none;
    background: url("https://cardiff.b-cdn.net/img/gradient-mobile.png");
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
  }
  .notes {
    /* margin-left: 32px; */
    margin-left: 8%;
  }
  #main_container {
    display: block;
    padding-top: 14px;
  }
  #image_container_desktop {
    display: none;
  }
  .iphone_plaid_mobile {
    display: block;
    margin: 0 auto;
  }
  #logo {
    width: 90%;
    width: 340px;
    height: 208px;
    padding-top: 0;
    display: unset !important;
  }
  /* #image_title_container {
    display: unset;
  } */
  .bank_icon {
    display: unset !important;
  }
  #advantages_title {
    font-size: 24px;
    margin-left: 8%;
    margin-right: 8%;
  }
  .advantages_item {
    font-size: 16px;
    margin-left: 8%;
    margin-right: 8%;
  }
  .advantage_separator {
    margin-left: 8%;
    margin-right: 8%;
  }
  .pure-button {
    margin: 0 auto;
  }
}
</style>